<template>
	<el-card>
		<!-- 筛选表单 -->
		<div class="clearfloat">
			<el-form
				class="searchForm left"
				ref="tableFilter"
				inline
				:model="tableFilter"
			>
				<el-form-item label="故障代码" prop="code">
					<el-input size="mini" v-model="tableFilter.code"></el-input>
				</el-form-item>
				<el-form-item
					label="产品类型"
					class="marginL10"
					prop="productTypeId"
				>
					<el-select
						size="mini"
						v-model="tableFilter.productTypeId"
						@change="(val) => getProductModels('filter', val)"
						clearable
					>
						<el-option
							v-for="item in productTypes"
							:key="item.id"
							:value="item.id"
							:label="item.productType"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item
					label="产品型号"
					class="marginL10"
					prop="productId"
				>
					<el-select
						:disabled="tableFilter.productTypeId == null"
						size="mini"
						v-model="tableFilter.productId"
						clearable
					>
						<el-option
							v-for="item in productModels4Filter"
							:key="item.id"
							:value="item.id"
							:label="item.productModel"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" @click="handleResetFilter">
						重置
					</el-button>
					<el-button type="primary" size="mini" @click="getList">
						搜索
					</el-button>
				</el-form-item>
			</el-form>
			<el-button
				class="right"
				v-if="btnPer('sta_importFaultCode')"
				type="primary"
				size="mini"
				style="margin-top: 7px;"
				@click="handleImport"
			>
				录入
			</el-button>
		</div>
		<!-- 表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column
				label="序号"
				fixed="left"
				type="index"
				width="80"
			></el-table-column>
			<el-table-column
				label="产品类型"
				prop="productTypeId"
				fixed="left"
				width="120"
				:formatter="(row) => escapeData('productType', row)"
			></el-table-column>
			<el-table-column
				label="产品型号"
				prop="productId"
				fixed="left"
				:formatter="(row) => escapeData('productModel', row)"
			></el-table-column>
			<el-table-column
				label="故障代码"
				prop="code"
				fixed="left"
			></el-table-column>
			<el-table-column
				label="故障含义"
				prop="content"
				fixed="left"
			></el-table-column>
			<el-table-column label="通知内容" width="200" prop="showMessage">
				<template slot-scope="scope">
					<el-tooltip
						effect="dark"
						:content="scope.row.showMessage"
						placement="top-start"
					>
						<span>{{
							$utils.handleDealLongTxt(scope.row.showMessage, 12)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column label="备注" prop="note" width="120">
				<template slot-scope="scope">
					<el-tooltip
						effect="dark"
						:content="scope.row.note"
						placement="top-start"
					>
						<span>{{
							$utils.handleDealLongTxt(scope.row.note, 12)
						}}</span>
					</el-tooltip>
				</template></el-table-column
			>
			<el-table-column
				label="创建时间"
				prop="createTime"
				width="200"
				:formatter="(row) => $utils.formatDate(row.createTime)"
			></el-table-column>
			<el-table-column
				label="更新时间"
				prop="updateTime"
				width="200"
				:formatter="(row) => $utils.formatDate(row.updateTime)"
			></el-table-column>
			<el-table-column label="操作" fixed="right" width="200">
				<template slot-scope="scope">
					<el-link
						:underline="false"
						size="mini"
						type="primary"
						v-if="btnPer('sta_editFaultCode')"
						@click.native.prevent="handleEdit(scope.row)"
					>
						编辑
					</el-link>
					<el-link
						class="marginL10"
						:underline="false"
						size="mini"
						type="danger"
						v-if="btnPer('sta_delFaultCode')"
						@click.native.prevent="handleDelete(scope.row)"
					>
						删除
					</el-link>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination
			class="pagination marginT20"
			align="right"
			@size-change="(pageSize) => getList('pageSize', pageSize, true)"
			@current-change="(page) => getList('page', page)"
			:current-page.sync="pageNumber"
			:page-sizes="[10, 20, 30, 40]"
			:page-size.sync="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
		></el-pagination>
		<!-- 弹窗 -->
		<el-dialog
			:title="act == 'edit' ? '编辑' : '录入'"
			width="50%"
			:visible.sync="dialogVisible"
			@closed="handleClose"
		>
			<el-form
				ref="form"
				:model="form"
				label-width="150px"
				:rules="rules"
			>
				<el-form-item label="产品类型" prop="productTypeId">
					<el-select
						v-model="form.productTypeId"
						@change="(val) => getProductModels('form', val)"
					>
						<el-option
							v-for="item in productTypes"
							:key="item.id"
							:value="item.id"
							:label="item.productType"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品型号" prop="productId">
					<el-select
						:disabled="form.productTypeId == null"
						v-model="form.productId"
						@change="getErrorCodes"
					>
						<el-option
							v-for="item in productModels"
							:key="item.id"
							:value="item.id"
							:label="item.productModel"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="故障代码" prop="code">
					<el-select
						:disabled="form.productId == null"
						v-model="form.code"
						@change="getErrorContent"
					>
						<el-option
							v-for="(item, idx) in errCodes"
							:key="idx"
							:value="idx"
							:label="idx"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="故障含义" prop="content">
					<span>{{ form.content }}</span>
				</el-form-item>
				<el-form-item label="通知内容" prop="showMessage">
					<el-input
						v-model="form.showMessage"
						type="textarea"
						rows="3"
					></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="note">
					<el-input
						v-model="form.note"
						type="textarea"
						rows="3"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="beforeSubmit">
					确 定
				</el-button>
			</span>
		</el-dialog>
	</el-card>
</template>

<script>
export default {
	data() {
		return {
			total: 0,
			dialogVisible: false,
			act: "",
			startEdit: false,
			productTypes: [],
			productModels: [],
			productModels4Filter: [],
			productModelsAll: [],
			pageNumber: 1,
			pageSize: 10,
			tableFilter: {
				code: "",
				productTypeId: null,
				productId: null,
			},
			form: {
				productTypeId: null,
				productId: null,
				code: "",
				content: "",
				note: "",
				showMessage: "",
			},
			errCodes: [],
			rules: {
				productTypeId: [
					{
						required: true,
						message: "请选择产品类型",
						trigger: "blur",
					},
				],
				productId: [
					{
						required: true,
						message: "请选择产品型号",
						trigger: "blur",
					},
				],
				code: [
					{
						required: true,
						message: "请选择故障代码",
						trigger: "blur",
					},
				],
				content: [
					{
						required: true,
						message: "请选择故障代码",
						trigger: "blur",
					},
				],
				showMessage: [
					{
						required: true,
						message: "请输入通知内容",
						trigger: "blur",
					},
				],
			},
			tableData: [],
		};
	},
	created() {
		this.getList();
		this.getProductTypes();
		this.getProductModelsAll();
	},
	methods: {
		getList: function (type, val, isReload = false) {
			isReload ? this.pageNumber = 1 : null;
			if (type) {
				this[type] = val;
			}
			let para = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				...this.tableFilter,
			};
			console.log(para);
			this.$http.standFaults(para).then((res) => {
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
			});
		},
		// 编辑
		handleEdit: function (row) {
			let para = Object.assign({}, row);
			this.dialogVisible = true;
			this.act = "edit";
			this.$nextTick((res) => {
				this.startEdit = true;
				this.form = para;
				this.getProductModels("form", para.productTypeId);
				this.getErrorCodes(para.productId);
			});
		},
		// 录入
		handleImport: function () {
			this.act = "add";
			this.dialogVisible = true;
		},
		// 删除
		handleDelete: function (row) {
			this.$confirm(
				"确认删除此故障代码（" +
					row.code +
					"）吗？删除此信息后，系统无法解析相应故障，Web及APP无法收到相应推送信息",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).then(() => {
				this.$http.standFaultDel(row.id).then((res) => {
					if (res.data.success) {
						this.getList();
					}
				});
			});
		},
		// 提交表单
		beforeSubmit: function () {
			this.$refs.form.validate((valid) => {
				if (valid) {
					if (this.act == "edit") {
						this.$confirm(
							"确认更新此故障代码(" +
								this.form.code +
								"）吗？更新此故障代码后，Web及APP相应推送信息将发生改变",
							"提示",
							{
								confirmButtonText: "确定",
								cancelButtonText: "取消",
								type: "warning",
							}
						).then(() => {
							this.handleSubmit();
						});
					} else {
						this.handleSubmit();
					}
				}
			});
		},
		// 提交表单
		handleSubmit: function () {
			let ajax =
				this.act == "add"
					? this.$http.standFaultAdd
					: this.$http.standFaultEdit;
			ajax(this.form).then((res) => {
				if (res.data.success) {
					this.getList();
					this.dialogVisible = false;
				}
			});
		},
		// 关闭弹窗
		handleClose: function () {
			this.$refs.form.resetFields();
			this.dialogVisible = false;
		},
		// 重置筛选表单
		handleResetFilter: function () {
			this.$refs.tableFilter.resetFields();
		},
		// —————————————— 获取关联数据 ——————————————
		// 获取产品类型列表
		getProductTypes: function () {
			this.$http.productTypesAll().then((res) => {
				if (res.data.success) {
					this.productTypes = res.data.data;
				}
			});
		},
		// 获取产品型号列表
		getProductModels: function (type, val) {
			if (val) {
				this.$http
					.productModuleAll({
						productTypeId: val,
					})
					.then((res) => {
						if (res.data.success) {
							if (type == "filter") {
								this.productModels4Filter = res.data.data;
							} else {
								this.productModels = res.data.data;
								if (this.startEdit) {
									this.startEdit = false;
								} else {
									this.form.productId = null;
									this.form.code = null;
								}
							}
						}
					});
			} else {
				if (type == "filter") {
					this.productModels4Filter = [];
					this.tableFilter.productId = null;
				} else {
					this.productModels = [];
					this.form.productId = null;
					this.form.code = null;
				}
			}
		},
		// 获取产品型号列表
		getProductModelsAll: function (type, val) {
			this.$http.productModuleAll().then((res) => {
				if (res.data.success) {
					this.productModelsAll = res.data.data;
					this.form.code = null;
				}
			});
		},
		// 获取故障码属性
		getErrorCodes: function (val) {
			this.$http
				.productModelFuncListALL({
					productId: val,
				})
				.then((res) => {
					res.data.data.forEach((item) => {
						if (item.identify == "error_code") {
							this.errCodes = JSON.parse(item.bounds).items;
						}
					});
				});
		},
		// 获取故障含义
		getErrorContent: function (val) {
			this.form.content = this.errCodes[val];
		},
		// 转化数据
		escapeData: function (type, row) {
			switch (type) {
				case "productType":
					for (let i in this.productTypes) {
						if (this.productTypes[i].id == row.productTypeId) {
							return this.productTypes[i].productType;
						}
					}
					return "--";
				case "productModel":
					for (let i in this.productModelsAll) {
						if (this.productModelsAll[i].id == row.productId) {
							return this.productModelsAll[i].productModel;
						}
					}
					return "--";
				default:
					return "--";
			}
		},
		// 判断按钮权限
		btnPer: function (name) {
			let list = this.$store.state.standard.menuNodeList,
				flag = false;
			for (let i in list) {
				if (list[i].href == name) {
					flag = true;
					break;
				}
			}
			return flag;
		},
	},
};
</script>

<style lang='less' scoped>
.searchForm {
	width: 90%;
}
</style>